"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLostContainer = exports.SessionLost = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@material-ui/core");
const react_1 = tslib_1.__importDefault(require("react"));
const authentication_service_1 = require("../authentication-service");
const oidc_service_1 = require("../oidc-service");
const SessionLost = ({ onAuthenticate }) => (react_1.default.createElement(core_1.Container, { maxWidth: "sm" },
    react_1.default.createElement(core_1.Typography, { component: "h1", gutterBottom: true }, "Session timed out"),
    react_1.default.createElement(core_1.Typography, { variant: "body1" }, "Your session has expired. Please re-authenticate yourself."),
    react_1.default.createElement(core_1.Button, { onClick: onAuthenticate }, "re-authenticate")));
exports.SessionLost = SessionLost;
const SessionLostContainer = ({ history, SessionLostComponentOverride }) => {
    const callbackPath = history.location.search.replace('?path=', '');
    const onAuthenticate = () => {
        oidc_service_1.authenticateUser(authentication_service_1.getUserManager(), history.location, history)(true, callbackPath);
    };
    return SessionLostComponentOverride ? (react_1.default.createElement(SessionLostComponentOverride, { onAuthenticate: onAuthenticate })) : (react_1.default.createElement(exports.SessionLost, { onAuthenticate: onAuthenticate }));
};
exports.SessionLostContainer = SessionLostContainer;
//# sourceMappingURL=session-lost.js.map